import { DvaReducer } from '@/models/shared';
import { Subscription } from 'dva';
import type { NodeManagerModelState, ChangeAction, NodeManagerModelType } from './types';
import { initialState } from './initialState';
import { pageEffects } from './pageEffects';
import { exhibitEffects } from './exhibitEffects';
import { themeEffects } from './themeEffects';
import { settingEffects } from './settingEffects';

export type { NodeManagerModelState };
export * from './types';

const Model: NodeManagerModelType = {
  namespace: 'nodeManagerPage',
  state: initialState,
  effects: {
    ...pageEffects,
    ...exhibitEffects,
    ...themeEffects,
    ...settingEffects,
  },
  reducers: {
    change(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  subscriptions: {
    setup({}) {},
  },
};

export default Model;
